import { Network } from '@capacitor/network';
import { useCallback, useEffect, useState } from 'react';

export const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const updateStatus = useCallback(async () => {
    const status = await Network.getStatus();
    setIsOnline(status.connected);
  }, []);

  const handleOnline = useCallback(() => setIsOnline(true), []);
  const handleOffline = useCallback(() => setIsOnline(false), []);

  useEffect(() => {
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    void updateStatus();

    void Network.addListener('networkStatusChange', status => {
      setIsOnline(status.connected);
    });

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      void Network.removeAllListeners();
    };
  }, []);

  return { isOnline };
};
